<!--
  card-mobile-bind
  绑定手机号 & 设置密码
  @see update-pwd.vue
  @see bind-mobile.vue
  会将后台提前指定手机的卡领过来
-->

<template>
  <div style="height: 100%;background-color: #f7f8fa">
    <van-cell-group>
      <van-field v-model.trim="phone" label="手机号码" placeholder="请输入手机号码" @input="phoneInp" />
      <van-field v-model.trim="code" label="短信验证码" placeholder="请输入验证码">
        <van-button v-show="isVisibleCode" slot="button" round size="mini" type="info" @click="codeClick">发送验证码
        </van-button>
        <van-button v-show="!isVisibleCode" slot="button" disabled size="small" type="info"> {{ disabledCodeText }} 秒后重新获取
        </van-button>
      </van-field>

      <!-- 初次来的 要设密码 已有手机号的就不用设密码 -->
      <div v-if="!userMobile || userMobile.length !== 11">
        <van-field :value="payPwd" clickable label="支付密码" placeholder="请输入6位数字密码" readonly type="password"
          @touchstart.native.stop="payPwdShow = true; payPwdOkShow = false" />
        <van-number-keyboard v-model="payPwd" :maxlength="6" :show="payPwdShow" @blur="payPwdShow = false" />
        <van-field :value="payPwdOk" clickable label="确认密码" placeholder="请输入6位数字密码" readonly type="password"
          @touchstart.native.stop="payPwdOkShow = true; payPwdShow = false" />
        <van-number-keyboard v-model="payPwdOk" :maxlength="6" :show="payPwdOkShow" @blur="payPwdOkShow = false" />
      </div>
    </van-cell-group>
    <div style="margin: 16px;">
      <van-button block class="login-btn" round type="info" @click="nextClick">下一步</van-button>
    </div>

    <div style="text-align: center;width: 100%;position: absolute;bottom: 50px">
      <router-link to="/help" style="text-align: center">无法收取到短信？</router-link>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant'
import { activeUserCards, send_validate_code_sms, validateCode, validateSmsCode } from '@/api/user'

export default {
  name: "card-mobile-bind",

  data() {
    return {
      phone: '',
      code: '',
      cardPwd: '',
      payPwd: '',
      payPwdShow: false,
      payPwdOk: '',
      payPwdOkShow: false,
      payPwd2: '',
      isVisibleCode: true,
      disabledCodeText: '',
      time: 120,
      userMobile: ''
    }
  },

  created() {
    this.userMobile = this.$store.getters.userInfo.mobile || '';
    budo_log.info("#78 created userMobile = ", this.userMobile)
  },

  methods: {
    phoneInp() {
      if (this.phone.length > 11) {
        this.phone = this.phone.substring(0, 11)
      }
    },

    // 点击发送验证码
    codeClick() {
      if (this.checkPhone()) {
        this.isVisibleCode = false
        this.getTime()
        send_validate_code_sms(this.phone).then(res => {
          budo_log.info("#79 send_validate_code_sms", res)
        })
      }
    },

    nextClick() {
      if (this.checkPhone()) {
        if (this.code === '') {
          Toast({ message: '验证码不能为空', duration: 1000 })
          return
        }

        if (this.userMobile && this.userMobile.length === 11) {
          validateCode(this.phone, this.code).then(res => {
            if (res.code === 0) {
              this.active_user_cards()
            } else {
              Toast(res.msg || '验证码错误 A')
            }
          })
        } else {
          if (this.payPwd === '') {
            Toast({ message: '密码不能为空', duration: 1000 })
            return
          }
          if (this.payPwd !== this.payPwdOk) {
            Toast({ message: '两次输入密码不一致', duration: 1000 })
            return
          }

          // /mall/wx/wx-user-validate-sms-code
          validateSmsCode(this.phone, this.code, this.payPwd).then(res => {
            if (res.code === 0) {
              this.active_user_cards()
            } else {
              Toast(res.msg || '验证码错误 B')
            }
          })
        }
      }
    },

    // active-user-cards
    active_user_cards() {
      activeUserCards().then(activeRes => {
        if (activeRes.code === 0) {
          if (sessionStorage.getItem("rc.redirect_topic_list") === "1") {
            this.$router.push({ path: 'topic-list' })
          } else {
            budo_log.info("#117 go bind-card-success")
            this.$router.push({ path: 'bind-card-success' })
          }
        } else {
          Dialog({ message: '激活卡券失败：' + activeRes.msg }).then(() => {
            this.$store.dispatch("store_get_user_info").then(() => {
              this.$router.push({ path: 'topic-list' })
            })
          });
        }
      })
    },

    // 倒计时
    getTime() {
      this.time--
      this.disabledCodeText = this.time
      if (this.time === 0) {
        this.isVisibleCode = true
        this.time = 120
        return
      }

      setTimeout(() => {
        this.getTime()
      }, 1000)
    },

    // 手机号验证
    checkPhone() {
      if (!(/^1[3456789]\d{9}$/.test(this.phone))) {
        Toast({ message: '请输入正确的手机号', duration: 1000 })
        return false
      }
      return true
    }
  },
}
</script>
